// Build + trigger a client-side CSV download from the currently-loaded rows.
// (For full-dataset exports beyond the loaded page, add a server-side /exports
// endpoint following the features/paymentExport blob pattern — this covers the
// operator's "export what I'm looking at" need without a round-trip.)

const escapeCell = (value) => {
  const s = value === null || value === undefined ? '' : String(value)
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

/**
 * @param {string} filename
 * @param {{label: string, value: (row) => any}[]} columns
 * @param {object[]} rows
 */
export const downloadCsv = (filename, columns, rows = []) => {
  const header = columns.map((c) => escapeCell(c.label)).join(',')
  const body = rows.map((row) => columns.map((c) => escapeCell(c.value(row))).join(',')).join('\n')
  const csv = `${header}\n${body}`

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
